import React, { Component } from "react";
import { NavItem, Badge } from "reactstrap";
import { NavLink } from "react-router-dom";
import PerfectScrollbar from "react-perfect-scrollbar";
import classnames from "classnames";

import ApplicationMenu from "../../../components/common/ApplicationMenu";
import IntlMessages from "../../../helpers/IntlMessages";
class StockApplicationMenu extends Component {
  // Helper để tính toán số lượng mà không lặp code
  // Luôn tính trên data_all để đảm bảo số liệu chính xác
  getFilteredCount = (filterFunc) => {
    return this.props.data_all.filter(filterFunc).length;
  };

  render() {
    // Lấy data_all để tính toán, data để hiển thị tổng số hiện tại
    const { data_all, filter, filterData } = this.props;

    if (!data_all) {
      // Đề phòng trường hợp data_all chưa được truyền xuống
      return null;
    }

    // --- Các hàm tính toán số lượng ---
    // Chúng ta tính toán trực tiếp ở đây, hoặc tốt hơn là dùng useMemo nếu là functional component
    // Với class component, việc tính toán trong render() vẫn tốt hơn cách cũ rất nhiều
    const countLessThan50 = this.getFilteredCount(
      (item) => (item.count / item.total) * 100 <= 50,
    );
    const countLessThan20 = this.getFilteredCount(
      (item) => (item.count / item.total) * 100 <= 20,
    );
    const countLessThan10 = this.getFilteredCount(
      (item) => (item.count / item.total) * 100 <= 10,
    );

    const countWithPriceNew = this.getFilteredCount((item) => !!item.price_new);
    const countWithoutPriceNew = this.getFilteredCount(
      (item) => !item.price_new,
    );

    const getnDaysAgoCount = (nDaysAgo) => {
      // Logic phải giống hệt trong filterData
      const endDate = new Date();
      endDate.setHours(23, 59, 59, 999);
      const endTimestamp = endDate.getTime();

      const startDate = new Date();
      startDate.setDate(startDate.getDate() - (nDaysAgo - 1));
      startDate.setHours(0, 0, 0, 0);
      const startTimestamp = startDate.getTime();

      return this.getFilteredCount((e) => {
        const itemTimestamp = new Date(e.updatedAt).getTime();
        return itemTimestamp >= startTimestamp && itemTimestamp <= endTimestamp;
      });
    };

    return (
      <ApplicationMenu>
        <PerfectScrollbar
          options={{ suppressScrollX: true, wheelPropagation: false }}
        >
          <div className="p-4">
            <p className="text-muted text-small">
              <IntlMessages id="menu.stock.inventory" />
            </p>
            <ul className="list-unstyled mb-5">
              {/* Tất cả */}
              <NavItem className={classnames({ active: !filter })}>
                <NavLink
                  to="#"
                  onClick={() => filterData("", "")}
                  location={{}}
                >
                  <span>
                    <IntlMessages id="general.all" />
                  </span>
                  <span className="float-right">{data_all.length}</span>
                </NavLink>
              </NavItem>
              {/* Dưới 50% */}
              <NavItem
                className={classnames({
                  active:
                    filter &&
                    filter.column === "percentage_less_than" &&
                    filter.value === 50,
                })}
              >
                <NavLink
                  to="#"
                  onClick={() => filterData("percentage_less_than", 50)}
                  location={{}}
                >
                  <span>
                    <IntlMessages id="menu.stock.less-than-50" />
                  </span>
                  <span className="float-right">{countLessThan50}</span>
                </NavLink>
              </NavItem>
              {/* Dưới 20% */}
              <NavItem
                className={classnames({
                  active:
                    filter &&
                    filter.column === "percentage_less_than" &&
                    filter.value === 20,
                })}
              >
                <NavLink
                  to="#"
                  onClick={() => filterData("percentage_less_than", 20)}
                  location={{}}
                >
                  <span>
                    <IntlMessages id="menu.stock.less-than-20" />
                  </span>
                  <span className="float-right">{countLessThan20}</span>
                </NavLink>
              </NavItem>
              {/* Dưới 10% */}
              <NavItem
                className={classnames({
                  active:
                    filter &&
                    filter.column === "percentage_less_than" &&
                    filter.value === 10,
                })}
              >
                <NavLink
                  to="#"
                  onClick={() => filterData("percentage_less_than", 10)}
                  location={{}}
                >
                  <span>
                    <IntlMessages id="menu.stock.less-than-10" />
                  </span>
                  <span className="float-right">{countLessThan10}</span>
                </NavLink>
              </NavItem>
            </ul>

            <p className="text-muted text-small">
              <IntlMessages id="menu.stock.cost-price" />
            </p>
            <ul className="list-unstyled mb-5">
              <NavItem
                className={classnames({
                  active:
                    filter &&
                    filter.column === "price_new_status" &&
                    filter.value === "done",
                })}
              >
                <NavLink
                  location={{}}
                  to="#"
                  onClick={() => filterData("price_new_status", "done")}
                  className="d-flex justify-content-between align-items-center"
                >
                  <div className="d-flex align-items-center">
                    <i className="simple-icon-check" />
                    <span>
                      <IntlMessages id="menu.stock.cost-price-done" />
                    </span>
                  </div>
                  <span className="float-right">{countWithPriceNew}</span>
                </NavLink>
              </NavItem>
              <NavItem
                className={classnames({
                  active:
                    filter &&
                    filter.column === "price_new_status" &&
                    filter.value === "not",
                })}
              >
                <NavLink
                  to="#"
                  location={{}}
                  onClick={() => filterData("price_new_status", "not")}
                  className="d-flex justify-content-between align-items-center"
                >
                  <div className="d-flex align-items-center">
                    <i className="simple-icon-close" />
                    <span>
                      <IntlMessages id="menu.stock.cost-price-not-yet" />
                    </span>
                  </div>
                  <span className="float-right">{countWithoutPriceNew}</span>
                </NavLink>
              </NavItem>
            </ul>
            <p className="text-muted text-small">
              <IntlMessages id="menu.stock.import-time" />
            </p>
            <ul className="list-unstyled mb-5">
              <NavItem
                className={classnames({
                  active:
                    filter &&
                    filter.column === "nDaysAgo" &&
                    filter.value === 5,
                })}
              >
                <NavLink
                  to="#"
                  onClick={() => filterData("nDaysAgo", 5)}
                  location={{}}
                >
                  <span>
                    <IntlMessages id="menu.stock.recent-5-days" />
                  </span>
                  <span className="float-right">{getnDaysAgoCount(5)}</span>
                </NavLink>
              </NavItem>
              <NavItem
                className={classnames({
                  active:
                    filter &&
                    filter.column === "nDaysAgo" &&
                    filter.value === 10,
                })}
              >
                <NavLink
                  to="#"
                  onClick={() => filterData("nDaysAgo", 10)}
                  location={{}}
                >
                  <span>
                    <IntlMessages id="menu.stock.recent-10-days" />
                  </span>
                  <span className="float-right">{getnDaysAgoCount(10)}</span>
                </NavLink>
              </NavItem>
            </ul>
          </div>
        </PerfectScrollbar>
      </ApplicationMenu>
    );
  }
}

export default StockApplicationMenu;
